import { getIsNativePlatform } from 'utils/platform';

import secureTokenStore from '../secureTokenStore';
import storage from '../storage';

import AccountsJwtService from './accountsJwtService';
import JwtManager from './jwtManager';

const tokenBackend = getIsNativePlatform() ? secureTokenStore : storage;

const jwtManager = new JwtManager(tokenBackend);
const accountsJwtService = new AccountsJwtService(storage, jwtManager);

export { jwtManager };

export default accountsJwtService;
